import React, { useEffect } from "react";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

import * as S from "../styles";

const EmailExistsModal = ({
  open,
  email,
  documentNumber,
  reason = "email",
  onChangeEmail,
  onLogin,
  onReactivate,
  reactivating,
  reactivateLabel = "Quero a Capicand-IA nessa conta",
}) => {
  const isDocumentReason = reason === "document";
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = e => {
      if (e.key === "Escape") onChangeEmail?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onChangeEmail]);

  if (!open) return null;

  return (
    <S.ModalOverlay open={open}>
      <S.EmailExistsDialog
        role="dialog"
        aria-modal="true"
        aria-labelledby="email-exists-title"
        aria-describedby="email-exists-desc"
      >
        <div className="icon">
          <ReportProblemOutlinedIcon sx={{ color: '#D83143 !important'}} />
        </div>
        <h3 id="email-exists-title">
          {isDocumentReason ? "CPF já cadastrado!" : "E-mail já cadastrado!"}
        </h3>
        <p id="email-exists-desc">
          {isDocumentReason ? (
            <>
              O CPF <strong>{documentNumber}</strong> já está cadastrado na Jusfy,
              você pode tentar fazer o login ou corrigir o CPF informado
            </>
          ) : (
            <>
              O e-mail <strong>{email}</strong> já está cadastrado na Jusfy,
              você pode tentar fazer o login com ele ou inserir outro e-mail
            </>
          )}
        </p>
        <div className="actions">
          <S.SecondaryButton type="button" onClick={onChangeEmail}>
            {isDocumentReason ? "Corrigir CPF" : "Inserir outro e-mail"}
          </S.SecondaryButton>
          <S.PrimaryButton type="button" onClick={onLogin}>
            Fazer login
          </S.PrimaryButton>
        </div>
        {onReactivate && (
          <S.LinkButton
            type="button"
            onClick={onReactivate}
            disabled={reactivating}
          >
            {reactivating ? "Verificando sua conta..." : reactivateLabel}
          </S.LinkButton>
        )}
      </S.EmailExistsDialog>
    </S.ModalOverlay>
  );
};

export default EmailExistsModal;
